import { Skeleton } from "@mui/material";
import { AccordionsProps } from "../components";


export function generateAccordionsSkeletonRows(count: number): AccordionsProps['rows'] {
    return Array.from({ length: count }, (_, index) => ({
        id: `loading-${index}`,
        TitleContent: <Skeleton
            width="90%"
            height={100}
            sx={{ ml: 2, mr: 3 }} />,
        Bodycontent: <Skeleton
            width="90%"
            height={100}
            sx={{ ml: 3, mr: 2 }} />
    }));
}